import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import BlogList from "@/pages/BlogList";
import ArticleDetail from "@/pages/ArticleDetail";
import About from "@/pages/About";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import CookieRichtlinien from "@/pages/CookieRichtlinien";
import Risikohinweis from "@/pages/Risikohinweis";
import CalculatorRendite from "@/pages/CalculatorRendite";
import CalculatorCO2 from "@/pages/CalculatorCO2";
import CalculatorGreenPremium from "@/pages/CalculatorGreenPremium";
import CalculatorGreenLever from "@/pages/CalculatorGreenLever";
import CalculatorESGFinder from "@/pages/CalculatorESGFinder";
import CalculatorNachhaltigkeitspraeferenz from "@/pages/CalculatorNachhaltigkeitspraeferenz";
import RechnerHub from "@/pages/RechnerHub";
import MarktreportPage from "@/pages/MarktreportPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminArticleEdit from "@/pages/AdminArticleEdit";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/components/AuthProvider";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/blog" element={<BlogList />} />
      <Route path="/artikel/:slug" element={<ArticleDetail />} />
      <Route path="/ueber-uns" element={<About />} />
      <Route path="/rechner" element={<RechnerHub />} />
      <Route path="/rechner/nachhaltigkeits-rendite" element={<CalculatorRendite />} />
      <Route path="/rechner/co2-fussabdruck" element={<CalculatorCO2 />} />
      <Route path="/rechner/green-premium" element={<CalculatorGreenPremium />} />
      <Route path="/rechner/gruener-hebel" element={<CalculatorGreenLever />} />
      <Route path="/rechner/nachhaltiger-etf-finder" element={<CalculatorESGFinder />} />
      <Route path="/rechner/nachhaltigkeitspraeferenz-assistent" element={<CalculatorNachhaltigkeitspraeferenz />} />
      <Route path="/nachhaltige-geldanlage-deutschland" element={<MarktreportPage />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/cookie-richtlinien" element={<CookieRichtlinien />} />
      <Route path="/risikohinweis" element={<Risikohinweis />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/artikel/:id"
        element={
          <ProtectedRoute>
            <AdminArticleEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/artikel/neu"
        element={
          <ProtectedRoute>
            <AdminArticleEdit />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
